import React, { createContext, FC, useEffect, useState } from 'react'
import { useDispatchService } from 'services'
import { authentication, LOAD_MANAGER_TI_HI_FEATURE_KEY } from 'utils'

type TiHiRolloutContextData = {
    isEligible: boolean
}

export const TiHiRolloutContext = createContext<TiHiRolloutContextData>({
    isEligible: false
})

export const TiHiRolloutProvider: FC = ({ children }) => {
    const [isEligible, setIsEligible] = useState(false)
    const { getDriverFeatureEligibility } = useDispatchService()

    useEffect(() => {
        let isMounted = true
        const driverId = authentication.getUser()?.driverId

        if (!driverId) {
            return () => {
                isMounted = false
            }
        }

        const loadEligibility = async (): Promise<void> => {
            try {
                const eligible = await getDriverFeatureEligibility(driverId, LOAD_MANAGER_TI_HI_FEATURE_KEY)
                if (isMounted) {
                    setIsEligible(eligible)
                }
            } catch (error) {
                console.warn('TI/HI feature eligibility lookup failed.', error)
                if (isMounted) {
                    setIsEligible(false)
                }
            }
        }

        void loadEligibility()

        return () => {
            isMounted = false
        }
    }, [])

    return (
        <TiHiRolloutContext.Provider value={{ isEligible }}>
            {children}
        </TiHiRolloutContext.Provider>
    )
}
